<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><a id="page_7"></a><a id="frontmatter01"></a><span class="underline">AUTHOR’S NOTE</span></h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">I like writing, and the experience is only improved when you have someone to bounce ideas off of, to find a way through the twists and turns of a plot, and to cheer you on when inspiration is lagging. It’s better still when the coauthor is someone whose judgment you trust as much or even more than your own.</p>
<p class="indent-para">I’ve known Chris Carlson for twenty-seven years, and we’ve worked together on a dozen projects of our own creation. His ability to process facts is only matched by his ability to tolerate my own fuzzy understanding of technology.</p>
<p class="indent-para">Each of us approached this story from a different angle, but instead of creating conflict, it made our combined work a richer story. It’s impossible to look at the text and say, “Chris wrote this,” or “I wrote that.” And why would I want to? This work is equally Chris’s and mine. By respecting and understanding what each of us brings to the task, we can do things together that would be impossible alone.</p>
<p class="indent-para">I’m already looking forward to the next one.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?3742cbb2